import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';

interface LoginOption {
  name: string
  handler: (auth: AuthService) => Promise<any>
}

const LOGIN_OPTIONS: readonly LoginOption[] = [
  { name: 'Google', handler: (auth: AuthService) => auth.loginWithGoogle() },
]

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  host: {
    class: 'app-fill-screen',
  }
})
export class LoginComponent {
  protected readonly loginOptions = LOGIN_OPTIONS

  private readonly authService = inject(AuthService)

  loginWith(option: LoginOption): void {
    option.handler(this.authService).finally()
  }
}
